// third-party
import { FormattedMessage } from 'react-intl';
// assets
import {
    ClipboardTick,
    UserTick,
    Airplane,
    User, Building,  SecurityUser, People,Briefcase,TaskSquare,Graph, ReceiptEdit, MoneyChange, MoneyArchive ,WalletMoney,MoneySend,EmptyWalletAdd
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  accounts: UserTick,
  dashboard:ClipboardTick,
  leaveType:Airplane,
  myAccounts:ClipboardTick,
  people: People,
  department:Briefcase,
  manager:SecurityUser,
  employee:User,
  project:Building,
  attendance:TaskSquare,
  report:Graph,
  quotation:MoneyArchive,
  invoice:ReceiptEdit,
  payment:MoneyChange,
  purchases:WalletMoney,
  expenses:MoneySend,
  assets:EmptyWalletAdd,
  vat:MoneyChange,


};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const accounts: NavItemType = {
  id: 'group-accounts',
  title: <FormattedMessage id="accounting"  />,
  icon: icons.accounts,
  type: 'collapse',
  // url: '/accounts',
  permissions:['NL_ACCOUNTING_R'],

  children: [
      // {
      //     id: 'accounts-my-accounts',
      //     title: <FormattedMessage id="reports" />,
      //     type: 'item',
      //     url: '/accounts',
      //     icon: icons.myAccounts,
      //   //   permissions:['NL_ATTENDANCE_ATTENDANCE_R','NL_ATTENDANCE_ATTENDANCE_C','NL_ATTENDANCE_ATTENDANCE_U','NL_ATTENDANCE_ATTENDANCE_D','NL_ATTENDANCE_ATTENDANCE_L','NL_ATTENDANCE_ATTENDANCE_U_ST'],

      // },
      {
        id: 'project-quotation',
        title: <FormattedMessage id="quotation" />,
        type: 'item',
        url: '/accounts/quotation',
        icon: icons.quotation,
        breadcrumbs: true,
        permissions:['NL_ACCOUNTING_QUOTATION_R','NL_ACCOUNTING_QUOTATION_C','NL_ACCOUNTING_QUOTATION_U','NL_ACCOUNTING_QUOTATION_D','NL_ACCOUNTING_QUOTATION_L','NL_ACCOUNTING_QUOTATION_U_ST'],
        children: [
          {
            id: 'project-quotation-list',
            title: <FormattedMessage id="project-quotation-list" />,
            type: 'item',
            url: '/accounts/quotation',
            icon: icons.project,
            breadcrumbs: true
          },
          {
            id: 'project-quotation-new',
            title: <FormattedMessage id="project-quotation-new" />,
            type: 'item',
            url: '/accounts/quotation/new-quotation/',
            icon: icons.project,
            breadcrumbs: true
          },
          {
            id: 'project-quotation-new',
            title: <FormattedMessage id="project-quotation-edit" />,
            type: 'item',
            url: '/accounts/quotation/edit-quotation/1',
            icon: icons.project,
            breadcrumbs: true
          },
        ]
      },
      {
          id: 'accounts-invoice',
          title: <FormattedMessage id="invoices" />,
          type: 'item',
          url: '/accounts/invoices',
          icon: icons.invoice,
          permissions:['NL_ACCOUNTING_INVOICES_R','NL_ACCOUNTING_INVOICES_C','NL_ACCOUNTING_INVOICES_U','NL_ACCOUNTING_INVOICES_D','NL_ACCOUNTING_INVOICES_L','NL_ACCOUNTING_INVOICES_U_ST'],
     },

      {
          id: 'accounts-purchase',
          title: <FormattedMessage id="purchases" />,
          type: 'item',
          url: '/accounts/purchases',
          icon: icons.purchases,
          permissions:['NL_ACCOUNTING_PURCHASES_R','NL_ACCOUNTING_PURCHASES_C','NL_ACCOUNTING_PURCHASES_U','NL_ACCOUNTING_PURCHASES_D','NL_ACCOUNTING_PURCHASES_L','NL_ACCOUNTING_PURCHASES_U_ST'],
        },
      {
        id: 'accounts-expense',
        title: <FormattedMessage id="expenses" />,
        type: 'item',
        url: '/accounts/expenses',
        icon: icons.expenses,
        permissions:['NL_ACCOUNTING_ADMIN_EXPENSES_R','NL_ACCOUNTING_ADMIN_EXPENSES_C','NL_ACCOUNTING_ADMIN_EXPENSES_U','NL_ACCOUNTING_ADMIN_EXPENSES_D','NL_ACCOUNTING_ADMIN_EXPENSES_L','NL_ACCOUNTING_ADMIN_EXPENSES_U_ST'],
    },
    {
        id: 'accounts-assets',
        title: <FormattedMessage id="assets" />,
        type: 'item',
        url: '/accounts/assets',
        icon: icons.assets,
        permissions:['NL_ACCOUNTING_ASSETS_R','NL_ACCOUNTING_ASSETS_C','NL_ACCOUNTING_ASSETS_U','NL_ACCOUNTING_ASSETS_D','NL_ACCOUNTING_ASSETS_L','NL_ACCOUNTING_ASSETS_U_ST'],
    },
    {
      id: 'accounts-payment',
      title: <FormattedMessage id="payments" />,
      type: 'item',
      url: '/accounts/payments',
      icon: icons.payment,
      breadcrumbs: true,
      permissions:['NL_ACCOUNTING_PAYMENTS_R','NL_ACCOUNTING_PAYMENTS_C','NL_ACCOUNTING_PAYMENTS_U','NL_ACCOUNTING_PAYMENTS_D','NL_ACCOUNTING_PAYMENTS_L','NL_ACCOUNTING_PAYMENTS_U_ST'],
      children: [
        {
          id: 'accounts-payment-list',
          title: <FormattedMessage id="accounts-payment-list" />,
          type: 'item',
          url: '/accounts/payments',
          icon: icons.payment,
          breadcrumbs: true
        },
        {
          id: 'accounts-payment-new',
          title: <FormattedMessage id="accounts-payment-new" />,
          type: 'item',
          url: '/accounts/payment/new-payment/',
          icon: icons.payment,
          breadcrumbs: true
        },
        {
          id: 'accounts-payment-new',
          title: <FormattedMessage id="accounts-payment-edit" />,
          type: 'item',
          url: '/accounts/payment/edit-payment/1',
          icon: icons.payment,
          breadcrumbs: true
        },
      ]
    },
    {
      id: 'accounts-vat',
      title: <FormattedMessage id="vat-setting" />,
      type: 'item',
      url: '/accounts/vat',
      icon: icons.vat,
      permissions:['NL_ACCOUNTING_VAT_R','NL_ACCOUNTING_VAT_C','NL_ACCOUNTING_VAT_U','NL_ACCOUNTING_VAT_D','NL_ACCOUNTING_VAT_L','NL_ACCOUNTING_VAT_U_ST'],
      breadcrumbs: false
    },
  ]
};

export default accounts;
